export default __webpack_public_path__ + "static/media/Axe_8.6b4caf93.png";